<template>
  <div>
    <a-modal
      width="40%"
      title="思政微课基本信息"
      destroy-on-close
      :visible.sync="visible"
      append-to-body
      ok-text="提交"
      cancel-text="取消"
      @ok="goStep"
      @cancel="handleCancel"
    >
      <div class="card-item">
        <div class="mt30">
          <div class="form-item">
            <div class="main-text-style">
              <span style="color: #f6350f">*</span> 思政微课名称
            </div>
            <div class="pl16">
              <a-input
                class="input-style-2"
                type="text"
                placeholder="请输入思政微课名称"
                :maxLength="100"
                :disabled="isEdit"
                v-model="info.name"
              />
            </div>
          </div>
        </div>
        <div class="mt30">
          <div class="form-item">
            <div class="main-text-style">
              <span style="color: #f6350f">*</span> 申报年份
            </div>
            <div class="pl16">
              <a-date-picker
                placeholder="请选择申报年份"
                :disabled="isEdit"
                v-model="info.applyYear"
                :open="yearShowOne"
                :locale="locale"
                :format="'YYYY'"
                mode="year"
                @openChange="openChangeOne"
                @panelChange="panelChangeOne"
                class="form-item-right"
              />
            </div>
          </div>
        </div>
        <div class="mt30">
          <div class="form-item">
            <div class="main-text-style">
              <span style="color: #f6350f">*</span> 创建时间
            </div>
            <div class="pl16">
              <a-date-picker
                class="form-item-right"
                placeholder="请选择创建时间"
                v-model="info.foundTime"
                :disabled="isEdit"
                :format="'YYYY-MM-DD'"
                :locale="locale"
              />
            </div>
          </div>
        </div>
        <div class="mt30">
          <div class="form-item" style="width: 100%">
            <div class="main-text-style">
              <span style="color: #f6350f">*</span> 所属专业
            </div>
            <div
              class="pl16"
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
              "
            >
              <a-select
                style="width: 32%"
                show-search
                v-model="info.basicMajorCategory"
                option-filter-prop="children"
                :filter-option="filterOption"
                :disabled="isEdit"
                @change="handleChange"
              >
                <a-select-option value="">请选择专业大类</a-select-option>
                <a-select-option v-for="item in zydlList" :value="item.id">
                  {{ item.name }}
                </a-select-option>
              </a-select>
              <a-select
                style="width: 32%"
                show-search
                v-model="info.basicMajorSubclass"
                option-filter-prop="children"
                :filter-option="filterOption"
                :disabled="isEdit"
                @change="handleChange1"
              >
                <a-select-option value="">请选择专业子类</a-select-option>
                <a-select-option v-for="item in zyzlList" :value="item.id">
                  {{ item.name }}
                </a-select-option>
              </a-select>
              <a-select
                style="width: 32%"
                show-search
                v-model="info.basicMajor"
                option-filter-prop="children"
                :filter-option="filterOption"
                :disabled="isEdit"
              >
                <a-select-option value="">请选择专业</a-select-option>
                <a-select-option v-for="item in zyList" :value="item.id">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </div>
          </div>
        </div>
        <div class="mt30">
          <div class="form-item" style="width: 100%">
            <div class="main-text-style">
              <span style="color: #f6350f">*</span> 所属课程
            </div>
            <div class="pl16">
              <a-select
                mode="tags"
                style="width: 100%"
                v-model="info.course"
                :disabled="isEdit"
                placeholder="请选择课程"
              >
                <a-select-option
                  v-for="item in kcList"
                  :value="item.courseName"
                >
                  {{ item.courseName }}
                </a-select-option>
              </a-select>
            </div>
          </div>
        </div>
        <div class="mt30">
          <div class="form-item">
            <div class="main-text-style">
              <span style="color: #f6350f">*</span> 课程类型
            </div>
            <div class="pl16">
              <a-select
                style="width: 100%"
                v-model="info.courseType"
                :disabled="isEdit"
                placeholder="请选择课程"
              >
                <a-select-option v-for="item in kclists" :value="item.value">
                  {{ item.title }}
                </a-select-option>
              </a-select>
            </div>
          </div>
        </div>
        <div class="mt30">
          <div class="form-item">
            <div class="main-text-style">
              <span style="color: #f6350f">*</span> 学习人次
            </div>
            <div class="pl16">
              <a-input-number
                class="input-style-2"
                type="text"
                placeholder="请输入学习人次"
                v-model="info.wkStudyNum"
                :maxLength="10"
                :disabled="isEdit"
              />
            </div>
          </div>
        </div>
        <div class="mt30">
          <div class="form-item">
            <div class="main-text-style">
              <span style="color: #f6350f">*</span> 级别
            </div>
            <div class="pl16">
              <a-select
                v-model="info.levelType"
                style="width: 100%"
                :disabled="isEdit"
              >
                <a-select-option
                  :value="item.text"
                  v-for="item in jblist"
                  :key="item.text"
                  >{{ item.title }}</a-select-option
                >
                <!-- <a-select-option value="其他" >{{
                item.title
              }}</a-select-option> -->
              </a-select>
            </div>
          </div>
        </div>
        <!-- <div class="mt30">
      <div class="form-item-upload">
        <div class="main-text-style">
          <span style="color: #f6350f">*</span>
          申报书上传
        </div>
        <div class="pl16">
          <a-upload
            :file-list="fileList"
            :disabled="isEdit"
            :remove="(file, fileList) => handleRemove(file, fileList)"
            :before-upload="(file, fileList) => beforeUpload(file, fileList)"
            accept=".pdf"
          >
            <a-button :disabled="isEdit || loading" :loading="loading">
              <a-icon type="upload" />上传附件
            </a-button>
            <span class="text2">注：请上传pdf格式的文件</span>
          </a-upload>
        </div>
      </div>
    </div> -->
      </div>
    </a-modal>
  </div>
</template>
  <script>
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
moment.locale("zh-cn");
import { baseURL } from "@/utils/request.js";
import { postAction, getAction } from "@/api";
import evidencelist from "@/components/common/evidencelist";
import newpreview from "@/components/common/newpreviews";
export default {
  name: "",
  components: {
    evidencelist,
    newpreview,
  },
  data() {
    return {
      visible: false,
      isEdit: false,
      showDeleteModel: false,
      info: {
        name: "",
        foundTime: "",
        basicMajorCategory: "",
        basicMajorSubclass: "",
        basicMajor: "",
        course: [],
        id: "",
        applyType: "3",
        applyYear: "",
        courseType: "",
        declarationName: "",
        declarationPath: "",
        wkStudyNum: "",
        levelType: "",
        applyNameId: "",
      },
      path: baseURL,
      zh_CN,
      locale,
      zydlList: [],
      zyzlList: [],
      zyList: [],
      kcList: [],
      kclists: [],
      yearShowOne: false,
      fileList: [],
      loading: false,
      ispre: false,
      oldInfo: {},
      jblist: [],
      applyNameList: [],
      showiframe: false,
      previewUrl: "",
      titlename: "",
      isxg: false,
      sj: {},
      taskId: null,
      detailId: null,
    };
  },
  methods: {
    init(type, data, taskId, detailId) {
      console.log("🚀 ~ init ~ data:", data);
      this.visible = true;
      this.zydl();
      this.getkclist();
      this.getkclists();
      this.getcgjb();
      this.getApplyNameList();
      this.taskId = taskId;
      this.detailId = detailId;
      if (data != null) {
        this.info = { ...data };

        if (
          data &&
          data.declarationName != "" &&
          data.declarationName != null &&
          data.declarationPath != "" &&
          data.declarationPath != null
        ) {
          this.fileList = [];
          let fileItem = {};
          fileItem.path = data.declarationPath;
          fileItem.name = data.declarationName;
          fileItem.uid = 1;
          this.fileList.push(fileItem);
        }

        if (data) {
          if (
            data.basicMajorCategory != "null" &&
            data.basicMajorCategory != ""
          ) {
            this.zyzl(data.basicMajorCategory);
          }
          if (
            data.basicMajorSubclass != "null" &&
            data.basicMajorSubclass != ""
          ) {
            this.zylist(data.basicMajorSubclass);
          }
          this.info.basicMajorSubclass = data.basicMajorSubclass;
          this.info.basicMajor = data.basicMajor;
        }
        if (data && data.applyId != "null" && data.applyId != "") {
          this.info.applyNameId = data.applyId;
        }
        if (data && data.course != "") {
          let course = data.course;
          this.info.course = [];
          let that = this;
          if (course.indexOf(",") > -1) {
            setTimeout(function () {
              that.info.course = course.split(",");
            }, 10);
          } else if (course.length > 0) {
            that.info.course = course;
          } else {
            let arr = [];
            arr.push(course);
            setTimeout(function () {
              that.info.course = arr;
              console.log("12345");
            }, 10);
          }
        }

        if (this.$parent.editInfo && this.$parent.editInfo?.type == "preview") {
          this.isEdit = true;
        }
      }
      console.log("🚀 ~ init ~ this.info:", this.info);
    },
    handleChangeApplyId(e) {
      console.log("🚀 ~ handleChangeApplyId ~ e:", e);
      this.$forceUpdate();
    },

    // 获取级别
    getcgjb() {
      getAction("/baseCommon/getDictItemsByCode?code=achievement_level").then(
        (res) => {
          if (res.code == 200) {
            this.jblist = res.result;
          }
        }
      );
    },
    getApplyNameList() {
      getAction("/lx/lxApply/getApplyNameList?applyType=1").then((res) => {
        if (res.code == 200) {
          this.applyNameList = res.result;
        }
      });
    },
    getkclists() {
      getAction("/baseCommon/getDictItemsByCode?code=course_type").then(
        (res) => {
          if (res.code == 200) {
            this.kclists = res.result;
          }
        }
      );
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    openChangeOne(status) {
      if (status) {
        this.yearShowOne = true;
      }
    },
    handleRemove(file, fileList) {
      this.fileList = this.fileList.filter((item) => {
        if (item.path.indexOf(file.name1) === -1) {
          return item;
        }
      });
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    beforeUpload(file, fileList) {
      this.handleUpload(file);
      return false;
    },
    handleUpload(file) {
      if (this.fileList.length >= 1) {
        this.$message.error("申报书只能上传一个文件,请移除后再上传");
        return;
      }
      this.loading = true;
      const formData = new FormData();
      formData.append("file", file);
      formData.append("biz", "linxuan");
      fileUpdate(formData).then((res) => {
        if (res.code === 0) {
          this.$message.success(`上传成功`);
          let fileItem = {};
          fileItem.path = res.message;
          fileItem.name = file.name;
          fileItem.uid = file.uid;
          this.fileList.push(fileItem);
          this.loading = false;
        } else {
          this.$message.error("上传失败");
        }
      });
    },
    // 得到年份选择器的值
    panelChangeOne(value) {
      //   	      console.log(value,"111111");
      this.info.applyYear = value;
      this.yearShowOne = false;
    },
    zydl() {
      getAction("/infrastructure/basicMajorCategory/allList", {}).then(
        (res) => {
          console.log(res);
          if (res.code === 200) {
            let data = res.result;
            if (data) {
              this.zydlList = data;
            }
          }
        }
      );
    },
    handleChange(value) {
      this.zyzl(value);
      this.info.basicMajorSubclass = "";
      this.info.basicMajor = "";
      this.zyList = [];
    },
    handleChange1(value) {
      this.zylist(value);
      this.info.basicMajor = "";
    },
    zyzl(id) {
      getAction("/infrastructure/basicMajorSubclass/queryByCategoryId", {
        gategoryId: id,
      }).then((res) => {
        //			console.log(res);
        if (res.code === 200) {
          let data = res.result;
          if (data) {
            this.zyzlList = data;
          }
        }
      });
    },
    zylist(id) {
      getAction("/infrastructure/basicMajor/queryBySubclassId", {
        subclassId: id,
      }).then((res) => {
        console.log(res);
        if (res.code === 200) {
          let data = res.result;
          if (data) {
            this.zyList = data;
          }
        }
      });
    },
    getkclist() {
      getAction("/lxBase/lxWkCourse/list", {}).then((res) => {
        console.log(res);
        if (res.code === 200) {
          let data = res.result.records;
          if (data) {
            this.kcList = data;
          }
        }
      });
    },
    handlePreview(f) {
      if (this.isEdit) {
        console.log(f, "44444"); // let url = f.url;
        // let index = url.lastIndexOf(".");
        // let result = url.substring(index + 1);
        // this.fileType = result;
        // if(url && (url.includes('http://') || url.includes('https://'))){
        //   this.fileUrl = f.url;
        // }else{
        //   this.fileUrl= baseURL+f.url;
        // }
        if (f.path != "" && f.path != null) {
          this.titlename = f.name;
          this.showiframe = true;
          this.previewUrl = f.path;
        } else {
          // this.$message.warning("建设总结方案暂未上传，请上传后预览");
        }
      }
    },
    handleCancel() {
      this.visible = false;
    },
    goStep() {
      if (this.info && this.info.name === "") {
        if (this.info.name === "" || this.info.name == undefined) {
          this.$message.info("请填写思政微课名称");
          return false;
        }
      } else if (
        (this.info && this.info.applyYear === "") ||
        this.info.applyYear == undefined
      ) {
        this.$message.info("请选择申报年份");
        return false;
      } else if (this.info && this.info.foundTime === "") {
        if (this.info.foundTime === "" || this.info.foundTime == undefined) {
          this.$message.info("请选择创建时间");
          return false;
        }
      }

      if (this.info && this.info.basicMajorCategory === "") {
        if (
          this.info.basicMajorCategory === "" ||
          this.info.basicMajorCategory == undefined
        ) {
          this.$message.info("请选择专业大类");
          return false;
        }
      }
      if (this.info && this.info.basicMajorSubclass === "") {
        if (
          this.info.basicMajorSubclass === "" ||
          this.info.basicMajorSubclass == undefined
        ) {
          this.$message.info("请选择专业子类");
          return false;
        }
      }

      if (this.info && this.info.basicMajor === "") {
        if (this.info.basicMajor === "" || this.info.basicMajor == undefined) {
          this.$message.info("请选择专业");
          return false;
        }
      }
      console.log(this.info.course);
      if (this.info && this.info.course.length == "0") {
        if (this.info.course.length == "0" || this.info.course == undefined) {
          this.$message.info("请选择课程");
          return false;
        }
      }
      if (
        (this.info && this.info.courseType === "") ||
        this.info.courseType == undefined
      ) {
        this.$message.info("请选择课程类型");
        return false;
      }

      if (
        (this.info && this.info.wkStudyNum === "") ||
        this.info.wkStudyNum == undefined
      ) {
        this.$message.info("请输入学习人次");
        return false;
      }
      if (
        (this.info && this.info.levelType === "") ||
        this.info.levelType == undefined
      ) {
        this.$message.info("请选择级别");
        return false;
      }
      // if (
      //   (this.info && this.info.applyNameId === "") ||
      //   this.info.applyNameId == undefined
      // ) {
      //   this.$message.info("请选择所属思政工作室");
      //   return false;
      // }
      // if (this.fileList.length == 0) {
      //   this.$message.info("请上传申报书");
      //   return false;
      // }
      const dateObj = new Date(this.info.foundTime);
      const year = dateObj.getFullYear();
      const month = dateObj.getMonth() + 1; // 月份是从 0 开始的，所以要加 1
      const date = dateObj.getDate();
      const formattedDate = `${year}-${month.toString().padStart(2, "0")}-${date
        .toString()
        .padStart(2, "0")}`;
      let course = this.info.course;
      if (Array.isArray(course)) {
        course = course.join(",");
      }
      //				console.log(course,"4567");
      let params = {
        applyType: this.info.applyType,
        name: this.info.name,
        basicMajorCategory: this.info.basicMajorCategory,
        foundTime: formattedDate,
        basicMajor: this.info.basicMajor,
        basicMajorSubclass: this.info.basicMajorSubclass,
        course: course,
        courseType: this.info.courseType,
        applyYear: new Date(this.info.applyYear).getFullYear() + "",
        id: this.info.id,
        // declarationName: this.fileList[0].name,
        // declarationPath: this.fileList[0].path,
        wkStudyNum: this.info.wkStudyNum,
        levelType: this.info.levelType,
        applyId: this.info.applyNameId,
      };
      // this.info.declarationName = this.fileList[0].name;
      // this.info.declarationPath = this.fileList[0].path;
      this.sj = params;
      this.gosave();
    },
    gosave() {
      let params = {
        taskId: this.taskId,
        afterJson: JSON.stringify({ ...this.sj }),
        detailId: this.detailId,
      };
      postAction("/audit/lxAuditTask/reSubmitTask", params).then((res) => {
        if (res.code == 200) {
          this.info.id = res.result.id;
          this.info.hasResource = res.result.hasResource;
          this.$message.success(res.message || "提交成功");
          // this.info.type=this.$parent.editInfo.type;
          this.visible = false;
          this.$emit("init", this.info);
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
  mounted() {},
};
</script>
  <style scoped lang="scss">
.card-item {
  // background: #ffffff;
  // box-shadow: 1px 2px 14px 7px rgba(180, 180, 180, 0.11);
  // padding: 12px 20px;
  // box-sizing: border-box;
  // margin-bottom: 24px;
  .title-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: 700;
    border-bottom: 1px solid #d9d9d9;
    .title-text {
      color: #2155b5;
      font-size: 20px;
      font-weight: bold;
      height: 40px;
      line-height: 40px;
      border-bottom: 3px solid #2155b5;
      padding: 0px 4px;
    }
    .btn-action {
      width: 100px;
      height: 30px;
      border-radius: 6px;
      font-weight: 400;
      cursor: pointer;
      line-height: 30px;
      margin-right: 10px;
      text-align: center;
    }
  }
}
.mt30 {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .form-item {
    display: flex;
    align-items: center;
    width: 100%;
    margin-bottom: 10px;
    .main-text-style {
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #121212;
      margin-bottom: 15px;
      width: 165px;
    }
    .pl16 {
      width: calc(100%- 235px);
    }
    .form-item-right {
      width: 100%;
    }
    // .form-item-right {
    //   width: 240px;
    // }
  }
  .form-item-upload {
    display: flex;
    align-items: center;
    .main-text-style {
      font-size: 19px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      margin-bottom: 15px;
      width: 165px;
    }
    .form-item-right {
      width: 240px;
    }
  }
}
.submit-btn-box {
  display: flex;
  align-items: center;
  justify-content: center;
  .btn-group {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 240px;
    margin-top: 50px;
    .btn-action {
      width: 116px;
      height: 40px;
      border-radius: 6px;
      font-weight: 400;
      cursor: pointer;
      line-height: 30px;
      line-height: 38px;
      text-align: center;
    }
  }
}

.input-style-2 {
  width: 100%;
  padding: 10px 20px;
  height: 54px;
  font-size: 18px !important;
  border: 1px solid #d9d9d9;
  color: #999999;
}
// /deep/ .ant-calendar-picker {
//   width: 50%;
// }
/deep/ .ant-select-selection--single,
/deep/ .ant-select-selection--multiple {
  padding: 10px 20px;
  height: 54px;
  font-size: 18px !important;
  border: 1px solid #d9d9d9;
  color: #999999;
}
/deep/ .ant-select-selection__rendered,
/deep/ .ant-select-selection--multiple .ant-select-selection__placeholder {
  margin-left: 0px;
}
/deep/ .ant-input {
  width: 100%;
  padding: 10px 20px;
  height: 54px;
  font-size: 18px !important;
  border: 1px solid #d9d9d9;
  color: #999999;
}
.plflex {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.text1 {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.mb15 {
  margin: 20px;
  width: 165px;
}
.mb15-item {
  border-bottom: 1px solid #e4e0e0;
  padding-bottom: 30px;
  margin-bottom: 30px;
}

.img-box {
  width: 18px;
  height: 18px;
  margin-right: 10px;
}
.img-box-2 {
  width: 19px;
  height: 19px;
  margin-right: 10px;
}
.text2 {
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  margin: 14px 0 15px 10px;
}
.img-box-4 {
  width: 12px;
  height: 12px;
  margin-right: 10px;
  margin-bottom: 5px;
}
.file-input-box {
  color: #2155b5;
}
.file {
  position: relative;
  width: 156px;
  height: 40px;
  background: #fff;
  border: 1px solid #2155b5;
  border-radius: 4px;
  padding: 4px 12px;
  overflow: hidden;
  color: #575757;
  text-decoration: none;
  text-indent: 0;
  line-height: 20px;
  margin-bottom: 15px;
}
.file input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
}
.file:hover {
  background: rgba(218, 218, 218, 0.2);
  color: #000;
  text-decoration: none;
}
</style>